import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { adminApi } from '../api/admin';
import { format } from 'date-fns';
import './TablePage.css';

const STATUS_LABELS: Record<string, string> = {
  pending: '대기중',
  delivered: '전달됨',
  viewed: '확인함',
  guessed: '픽 완료',
  awaiting_result: '결과대기',
  matched: '매칭성공',
  failed: '매칭실패',
  expired: '만료',
};

const PHASE_LABELS: Record<string, string> = {
  none: '-',
  hint: '힌트',
  message_1: '메시지1',
  message_2: '메시지2',
  message_3: '메시지3',
  full: '전체공개',
};

export default function ChainDetailPage() {
  const { id } = useParams<{ id: string }>();
  const [chain, setChain] = useState<any>(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    if (id) adminApi.getChainDetail(id).then(setChain).finally(() => setLoading(false));
  }, [id]);

  if (loading) return <div className="loading">로딩 중...</div>;
  if (!chain) return <div className="loading">체인을 찾을 수 없습니다</div>;

  return (
    <div className="table-page">
      <button className="back-btn" onClick={() => navigate('/chains')}>← 체인 목록</button>
      <h2>체인 상세</h2>

      <div className="detail-grid">
        <div className="detail-field">
          <div className="detail-label">루트 픽 ID</div>
          <div className="detail-value"><code>{chain.rootPickId}</code></div>
        </div>
        <div className="detail-field">
          <div className="detail-label">체인 길이</div>
          <div className="detail-value">{chain.length}</div>
        </div>
        <div className="detail-field">
          <div className="detail-label">순환 감지</div>
          <div className="detail-value">
            <span className={`badge ${chain.isCyclic ? 'matched' : 'green'}`}>
              {chain.isCyclic ? '순환 발생' : '정상'}
            </span>
          </div>
        </div>
      </div>

      <h3>노드 그래프</h3>
      <div className="chain-graph">
        {chain.nodes.map((node: any, i: number) => (
          <React.Fragment key={node.pickId}>
            {i > 0 && <div className="chain-arrow">→</div>}
            <div
              className={`chain-node chain-node-${node.status}`}
              onClick={() => navigate(`/picks/${node.pickId}`)}
            >
              <div className="chain-node-label">{node.pickerPhone || '?'}</div>
              <div className="chain-node-arrow">↓</div>
              <div className="chain-node-label">{node.pickedPhone || '?'}</div>
              <div className="chain-node-status">
                <span className={`badge ${node.status}`}>{STATUS_LABELS[node.status] || node.status}</span>
              </div>
              <div className="chain-node-phase">{PHASE_LABELS[node.revealPhase] || node.revealPhase}</div>
            </div>
          </React.Fragment>
        ))}
      </div>

      <h3>노드 목록</h3>
      <div className="table-wrapper">
        <table>
          <thead>
            <tr>
              <th>#</th>
              <th>픽 ID</th>
              <th>보낸사람</th>
              <th>받는사람</th>
              <th>상태</th>
              <th>공개단계</th>
              <th>생성일</th>
              <th>매칭일</th>
            </tr>
          </thead>
          <tbody>
            {chain.nodes.map((node: any, i: number) => (
              <tr key={node.pickId} className="clickable" onClick={() => navigate(`/picks/${node.pickId}`)}>
                <td>{i + 1}</td>
                <td><code>{node.pickId.slice(0, 8)}</code></td>
                <td>{node.pickerPhone || '-'}</td>
                <td>{node.pickedPhone || '-'}</td>
                <td><span className={`badge ${node.status}`}>{STATUS_LABELS[node.status] || node.status}</span></td>
                <td>{PHASE_LABELS[node.revealPhase] || node.revealPhase}</td>
                <td>{format(new Date(node.createdAt), 'MM-dd HH:mm')}</td>
                <td>{node.matchedAt ? format(new Date(node.matchedAt), 'MM-dd HH:mm') : '-'}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
